import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

const valueToColor = (value) => {
  if (value >= 85) return '#14532d';
  if (value >= 70) return '#15803d';
  if (value >= 55) return '#65a30d';
  if (value >= 40) return '#ca8a04';
  return '#b91c1c';
};

const RubricCell = ({ label, value }) => (
  <Box
    sx={{
      backgroundColor: valueToColor(value),
      borderRadius: 1,
      color: '#fff',
      p: 1.5,
      textAlign: 'center',
      minHeight: 72
    }}
  >
    <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
      {label}
    </Typography>
    <Typography variant="h6" sx={{ fontWeight: 700 }}>
      {Number.isFinite(value) ? Math.round(value) : '—'}
    </Typography>
  </Box>
);

const RubricHeatmap = ({ metrics = {} }) => {
  const {
    historyQuestions = 0,
    flow = 0,
    examinerQuestions = 0,
    empathy = 0,
    logicalSequencing = 0,
    appropriatePhrasing = 0,
    avoidanceMedicalJargon = 0
  } = metrics;

  return (
    <Grid container spacing={1.5}>
      <Grid item xs={6} md={3}>
        <RubricCell label="History" value={historyQuestions} />
      </Grid>
      <Grid item xs={6} md={3}>
        <RubricCell label="Flow" value={flow} />
      </Grid>
      <Grid item xs={6} md={3}>
        <RubricCell label="Examiner" value={examinerQuestions} />
      </Grid>
      <Grid item xs={6} md={3}>
        <RubricCell label="Empathy" value={empathy} />
      </Grid>
      <Grid item xs={4} md={4}>
        <RubricCell label="Sequencing" value={logicalSequencing} />
      </Grid>
      <Grid item xs={4} md={4}>
        <RubricCell label="Phrasing" value={appropriatePhrasing} />
      </Grid>
      <Grid item xs={4} md={4}>
        <RubricCell label="Jargon" value={avoidanceMedicalJargon} />
      </Grid>
    </Grid>
  );
};

export default RubricHeatmap;
